<template>
  <b-modal
    id="modal-invoice-filter"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    title="過瀘"
    headerClass="pr-3 py-2 border-bottom bgWhite"
    footerClass="px-3 py-2 border-top bgWhite"
    hide-footer
    no-close-on-backdrop
    size="lg"
    @shown="onModalShown"
  >
    <!-- <feather-icon
      @click="hide"
      style="position: absolute; right: 20px; top: -40px"
      size="18"
      icon="XIcon"
    /> -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <!-- 金額範圍篩選 -->
          <b-col cols="12">
            <b-form-group
              label="金額範圍："
              label-for="filter_amount_range"
              label-cols-md="3"
            >
              <div class="amount-range-container">
                <vue-slider
                  v-model="update.filter_amount_range"
                  :min="0"
                  :max="1000000"
                  :interval="1"
                  :tooltip="'always'"
                  :tooltip-formatter="formatTooltip"
                  :dot-size="20"
                  :height="6"
                  :process-style="{ backgroundColor: '#007bff' }"
                  :rail-style="{ backgroundColor: '#e9ecef' }"
                  :dot-style="{ backgroundColor: '#007bff', border: '2px solid #fff', boxShadow: '0 2px 4px rgba(0,0,0,0.2)' }"
                  class="mb-1"
                  @change="updateInputFields"
                />
                <div class="d-flex justify-content-between align-items-center mt-2">
                  <div class="d-flex align-items-center">
                    <span class="text-muted small mr-1">HK$</span>
                    <b-form-input
                      v-model="update.filter_min_amount_input"
                      type="number"
                      min="0"
                      max="1000000"
                      step="any"
                      placeholder="0"
                      size="sm"
                      style="width: 80px;"
                      @input="updateMinAmount"
                    />
                  </div>
                  <span class="font-weight-bold text-primary mx-2">
                    HK${{ formatAmount(update.filter_amount_range[0]) }} - HK${{ formatAmount(update.filter_amount_range[1]) }}
                  </span>
                  <div class="d-flex align-items-center">
                    <span class="text-muted small mr-1">HK$</span>
                    <b-form-input
                      v-model="update.filter_max_amount_input"
                      type="number"
                      min="0"
                      max="1000000"
                      step="any"
                      placeholder="1000000"
                      size="sm"
                      style="width: 100px;"
                      @input="updateMaxAmount"
                    />
                  </div>
                </div>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="類別："
              label-for="filter_invoice_type_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_invoice_type_id"
                v-model="update.filter_invoice_type_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="invoiceTypeOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇類別"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" v-if="user_type_id !=2">
            <b-form-group
              label="客戶："
              label-for="filter_customer_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_customer_id"
                v-model="update.filter_customer_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="customerOptions"
                label="name_cn"
                :reduce="(option) => option.id"
                placeholder="選擇客戶"
                :filter="customerSearch"
              >
                <template #option="{ name_cn, user_number }">
                  [{{ user_number }}] {{ name_cn }}
                </template>
                <template #selected-option="{ name_cn, user_number }">
                  [{{ user_number }}] {{ name_cn }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <!-- <b-col cols="12">
            <b-form-group
              label="項目："
              label-for="filter_project_id"
              label-cols-md="3"
             
            >
              <v-select
                id="filter_project_id"
                v-model="update.filter_project_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="projectOptions"
                label="項目"
                :reduce="(option) => option.id"
                placeholder="選擇項目"
                :filter="projectSearch"
              >
                <template #option="{ project_name, project_number }">
                  [{{ project_number }}] {{ project_name }}
                </template>
                <template #selected-option="{ project_name, project_number }">
                  [{{ project_number }}] {{ project_name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col> -->

          <b-col cols="12">
            <b-form-group
              label="商品："
              label-for="filter_product_id"
              label-cols-md="3"
              
            >
              <v-select
                id="filter_product_id"
                v-model="update.filter_product_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="productOptions"
                label="name"
                :reduce="(option) => option.id"
                placeholder="選擇商品"
                :filter="productSearch"
              >
                <template #option="{ product_name, product_number }">
                  [{{ product_number }}] {{ product_name }}
                </template>
                <template #selected-option="{ product_name, product_number }">
                  [{{ product_number }}] {{ product_name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="報價單："
              label-for="quotation_id"
              label-cols-md="3"

            >
              <v-select
                id="filter_quotation_id"
                v-model="update.filter_quotation_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="quotationOptions"
                :clearable="true"
                label="id"
                :reduce="(option) => option.id"
                placeholder="選擇報價單"
                :filter="quotationSearch"
              >
                <template #option="{ quotation_number, name_cn }">
                  {{ quotation_number }} {{ name_cn }}
                </template>
                <template #selected-option="{ quotation_number, name_cn }">
                  {{ quotation_number }} {{ name_cn }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>


          <!-- 日期範圍篩選 -->
          <b-col cols="12">
            <b-form-group
              label="發單日期："
              label-for="filter_start_date"
              label-cols-md="3"
            >
              <div class="d-flex align-items-center gap-2">
                <b-form-datepicker
                  id="filter_start_date"
                  v-model="update.filter_start_date"
                  :max="update.filter_end_date"
                  placeholder="開始日期"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="zh-TW"
                  :state="dateValidationState.start"
                  reset-button
                  close-button
                  class="flex-1"
                />
                <span class="text-muted px-2">至</span>
                <b-form-datepicker
                  id="filter_end_date"
                  v-model="update.filter_end_date"
                  :min="update.filter_start_date"
                  placeholder="結束日期"
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  locale="zh-TW"
                  :state="dateValidationState.end"
                  reset-button
                  close-button
                  class="flex-1"
                />
              </div>
              <b-form-invalid-feedback v-if="dateValidationState.start === false || dateValidationState.end === false">
                開始日期不能晚於結束日期
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="付款狀態："
              label-for="filter_payment_status"
              label-cols-md="3"
            >
              <v-select
                id="filter_payment_status"
                v-model="update.filter_payment_status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="paymentStatusOptions"
                :clearable="true"
                label="label"
                :reduce="(option) => option.value"
                placeholder="選擇付款狀態"
              >
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="resetFilters"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            提交
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BFormInvalidFeedback,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import ability from "@/libs/acl/ability";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BCardBody,
    BCard,
    vSelect,
    flatPickr,
    VueSlider,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-invoice-filter");
    },
    onModalShown() {
      // Modal 顯示時重新同步 props 到內部狀態
      this.syncPropsToUpdate();
    },
    resetFilters() {
      this.update = {
        filter_invoice_type_id: null,
        filter_customer_id: null,
        filter_project_id: null,
        filter_product_id: null,
        filter_quotation_id: null,
        filter_payment_status: null,
        filter_start_date: null,
        filter_end_date: null,
        filter_amount_range: [0, 1000000],
        filter_min_amount_input: 0,
        filter_max_amount_input: 1000000,
      };
    },
    formatAmount(amount) {
      return new Intl.NumberFormat('zh-HK').format(amount);
    },
    formatTooltip(value) {
      return `HK$${this.formatAmount(value)}`;
    },
    updateMinAmount() {
      const minValue = parseInt(this.update.filter_min_amount_input) || 0;
      const maxValue = this.update.filter_amount_range[1];
      if (minValue <= maxValue) {
        this.update.filter_amount_range = [minValue, maxValue];
      }
    },
    updateMaxAmount() {
      const maxValue = parseInt(this.update.filter_max_amount_input) || 1000000;
      const minValue = this.update.filter_amount_range[0];
      if (maxValue >= minValue) {
        this.update.filter_amount_range = [minValue, maxValue];
      }
    },
    updateInputFields() {
      this.update.filter_min_amount_input = this.update.filter_amount_range[0];
      this.update.filter_max_amount_input = this.update.filter_amount_range[1];
    },
    syncPropsToUpdate() {
      // 同步所有 props 到內部 update 狀態，處理 undefined 值
      this.update.filter_invoice_type_id = this.filter_invoice_type_id || null;
      this.update.filter_customer_id = this.filter_customer_id || null;
      this.update.filter_project_id = this.filter_project_id || null;
      this.update.filter_product_id = this.filter_product_id || null;
      this.update.filter_quotation_id = this.filter_quotation_id || null;
      this.update.filter_payment_status = this.filter_payment_status || null;
      this.update.filter_start_date = this.filter_start_date || null;
      this.update.filter_end_date = this.filter_end_date || null;

      // 同步金額範圍，處理 undefined 值
      if (this.filter_min_amount !== null && this.filter_min_amount !== undefined) {
        this.update.filter_amount_range[0] = this.filter_min_amount;
        this.update.filter_min_amount_input = this.filter_min_amount;
      } else {
        this.update.filter_amount_range[0] = 0;
        this.update.filter_min_amount_input = 0;
      }

      if (this.filter_max_amount !== null && this.filter_max_amount !== undefined) {
        this.update.filter_amount_range[1] = this.filter_max_amount;
        this.update.filter_max_amount_input = this.filter_max_amount;
      } else {
        this.update.filter_amount_range[1] = 1000000;
        this.update.filter_max_amount_input = 1000000;
      }
    },
    onSubmit() {
      // 驗證日期範圍
      if (this.dateValidationState.start === false || this.dateValidationState.end === false) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "日期範圍錯誤",
            text: "開始日期不能晚於結束日期",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
        return;
      }

      this.$emit(
        "update:filter_invoice_type_id",
        this.update.filter_invoice_type_id
      );
      this.$emit("update:filter_customer_id", this.update.filter_customer_id);
      this.$emit("update:filter_product_id", this.update.filter_product_id);
      this.$emit("update:filter_project_id", this.update.filter_project_id);
      this.$emit("update:filter_quotation_id", this.update.filter_quotation_id);
      this.$emit("update:filter_payment_status", this.update.filter_payment_status);
      this.$emit("update:filter_start_date", this.update.filter_start_date);
      this.$emit("update:filter_end_date", this.update.filter_end_date);
      this.$emit("update:filter_min_amount", this.update.filter_amount_range[0]);
      this.$emit("update:filter_max_amount", this.update.filter_amount_range[1]);
      this.hide();
    },
    quotationSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.quotation_number.toLowerCase().includes(search.toLowerCase()) ||
          item.name_cn.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    customerSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.name_cn.toLowerCase().includes(search.toLowerCase()) ||
          item.user_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    projectSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.project_name.toLowerCase().includes(search.toLowerCase()) ||
          item.project_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    productSearch(options, search) {
      return options.filter((item) => {
        return item.product_name.toLowerCase().includes(search.toLowerCase());
      });
    },
  },
  props: {
    invoiceTypeOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    productOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    quotationOptions: {
      type: Array,
      required: true,
    },
    filter_invoice_type_id: {},
    filter_customer_id: {},
    filter_project_id: {},
    filter_product_id: {},
    filter_quotation_id: {},
    filter_payment_status: {},
    filter_start_date: {},
    filter_end_date: {},
    filter_min_amount: {},
    filter_max_amount: {},
  },
  data() {
    return {
      loading: false,
      ability,
      user_type_id: JSON.parse(localStorage.getItem("userData")).user_type_id,
      paymentStatusOptions: [
        { label: '全部', value: null },
        { label: '未付清', value: 'unpaid' },
        { label: '已付清', value: 'paid' }
      ],
      update: {
        filter_invoice_type_id: null,
        filter_customer_id: null,
        filter_project_id: null,
        filter_product_id: null,
        filter_quotation_id: null,
        filter_payment_status: null,
        filter_start_date: null,
        filter_end_date: null,
        filter_amount_range: [0, 1000000],
        filter_min_amount_input: 0,
        filter_max_amount_input: 1000000,
      },
    };
  },
  mounted() {
    // 初始化時同步 props 到內部狀態
    this.syncPropsToUpdate();
  },
  watch: {
    // 監聽 props 變化並同步到內部狀態
    filter_invoice_type_id(newVal) {
      this.update.filter_invoice_type_id = newVal || null;
    },
    filter_customer_id(newVal) {
      this.update.filter_customer_id = newVal || null;
    },
    filter_project_id(newVal) {
      this.update.filter_project_id = newVal || null;
    },
    filter_product_id(newVal) {
      this.update.filter_product_id = newVal || null;
    },
    filter_quotation_id(newVal) {
      this.update.filter_quotation_id = newVal || null;
    },
    filter_payment_status(newVal) {
      this.update.filter_payment_status = newVal || null;
    },
    filter_start_date(newVal) {
      this.update.filter_start_date = newVal || null;
    },
    filter_end_date(newVal) {
      this.update.filter_end_date = newVal || null;
    },
    filter_min_amount(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.update.filter_amount_range[0] = newVal;
        this.update.filter_min_amount_input = newVal;
      } else {
        this.update.filter_amount_range[0] = 0;
        this.update.filter_min_amount_input = 0;
      }
    },
    filter_max_amount(newVal) {
      if (newVal !== null && newVal !== undefined) {
        this.update.filter_amount_range[1] = newVal;
        this.update.filter_max_amount_input = newVal;
      } else {
        this.update.filter_amount_range[1] = 1000000;
        this.update.filter_max_amount_input = 1000000;
      }
    },
  },
  computed: {
    dateValidationState() {
      const start = this.update.filter_start_date;
      const end = this.update.filter_end_date;

      if (!start && !end) {
        return { start: null, end: null };
      }

      if (start && end) {
        const isValid = new Date(start) <= new Date(end);
        return {
          start: isValid ? true : false,
          end: isValid ? true : false,
        };
      }

      return { start: null, end: null };
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.gap-2 {
  gap: 0.5rem;
}

.flex-1 {
  flex: 1;
}

// 金額範圍滑桿樣式
.amount-range-container {
  padding: 0.5rem 0;

  // Vue Slider 自定義樣式
  .vue-slider {
    margin: 1rem 0;
  }

  // 工具提示樣式
  .vue-slider-dot-tooltip {
    background-color: #007bff !important;
    border-color: #007bff !important;

    &::before {
      border-top-color: #007bff !important;
    }
  }

  // 金額輸入欄位樣式
  .form-control {
    border: 1px solid #d1d3e2;
    border-radius: 0.35rem;
    font-size: 0.875rem;
    text-align: center;

    &:focus {
      border-color: #007bff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }
}

// 手機版響應式調整
@media (max-width: 576px) {
  .d-flex.align-items-center.gap-2 {
    flex-direction: column;
    align-items: stretch;

    .flex-1 {
      width: 100%;
    }

    .text-muted {
      text-align: center;
      padding: 0.25rem 0;
    }
  }
}
</style>